import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingBarService } from '@ngx-loading-bar/core';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  
  constructor(private  loadingBar: LoadingBarService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loadingBar.set(20); // Start the loading bar at 20%
    this.loadingBar.start(); // Start the loading bar progression

    return next.handle(req).pipe(
      finalize(() => this.loadingBar.complete()) // Complete the loading bar after the request finishes
    );
  }
}
